module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-infobox-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "order-infobox-modal__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "order-infobox-modal__header"
  }, [_c('h3', {
    staticClass: "order-infobox-modal__heading"
  }, [_vm._v("\n            Info\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7b6a774","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/InfoBox.vue
// module id = 889
// module chunks = 0